import axios from 'axios';
import BugInstruction from '@/models/bugInstruction';
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_BUG_INSTRUCTION_URL = process.env.VUE_APP_API_URL + '/bug_instructions';

// Teacher-facing CRUD for AI-authored bug instructions. Regular axios: the shared
// instance carries the auth header. applyErrorHandlers wraps every public static so
// reject paths normalise error.message (specs assert `.rejects.toBeTruthy()`).
export default class BugInstructionController {
  // List a subtask's bug instructions.
  static async getBySubtask(subtaskId) {
    const response = await axios.get(`${API_BUG_INSTRUCTION_URL}/by_subtask/${subtaskId}`);
    return (response.data || []).map((bi) => new BugInstruction(bi));
  }

  // Generate n new AI-authored bug instructions for a subtask (teacher-only).
  static async synthesize(subtaskId, n = 1) {
    const response = await axios.post(`${API_BUG_INSTRUCTION_URL}/synthesize`, {
      subtask_id: subtaskId,
      n,
    });
    return (response.data || []).map((bi) => new BugInstruction(bi));
  }

  // Delete a bug instruction by id.
  static async delete(bugInstructionId) {
    const response = await axios.delete(`${API_BUG_INSTRUCTION_URL}/${bugInstructionId}`);
    return response.data;
  }
}

applyErrorHandlers(BugInstructionController);
